import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import CheckmarkOutline from '../../../images/vector/checkmark-outline.svg';
import AudioView from '../../audio/TRCAudioView';
import successSound from '../../../sounds/success_sound.mp3';

export const TEST_SUCCESS_TIMEOUT = 1500;

const ReadingCheckSuccessCard = ({ text, onDone }) => {
    const [isAudioReadyToPlay, setAudioReadyToPlay] = useState(false);
    const [onDoneTimerId, setOnDoneTimerId] = useState(null);

    useEffect(() => {
        setOnDoneTimerId(setTimeout(onDone, TEST_SUCCESS_TIMEOUT));
        setAudioReadyToPlay(true);
    }, []);

    useEffect(() => {
        return () => clearTimeout(onDoneTimerId);
    }, []);

    return (
        <div className="mic-success-card">
            <div className="instruction-content">{text}</div>
            <CheckmarkOutline />
            <AudioView audioTracks={[successSound]} isReadyToPlay={isAudioReadyToPlay} />
        </div>
    );
};

ReadingCheckSuccessCard.propTypes = {
    text: PropTypes.string.isRequired,
    onDone: PropTypes.func.isRequired,
};

export default ReadingCheckSuccessCard;
